// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_1OmAd","checkmark":"_2FSez","wrapper":"z7ka2"};